// Quiz example: https://eveselibaspunkts.lv/lv/Article/Read/kraksana

// On Previous, Next, Finish or Restart button click
window.onClickQuizButton = (callerId, blockNumber) => {
    let activeItem = getActiveQuizItem(blockNumber)
    let newQuestionNumber
    let newItem

    try {
        switch (callerId) {
            case "QuizButtonPrev":
                // activeItem.id format = QuizQuestion.2.1
                newQuestionNumber = Number(activeItem.id.split(".")[2]) - 1
                clearQuizAnswers(blockNumber, newQuestionNumber + 1)
                break
            case "QuizButtonNext":
                newQuestionNumber = Number(activeItem.id.split(".")[2]) + 1
                break
            case "QuizButtonFinish":
                newQuestionNumber = 0 //0 - signal to hide next button
                newItem = getQuizResultElement(blockNumber)

                show(getElement("QuizButtonRestart." + blockNumber))
                hide(getElement("QuizButtonFinish." + blockNumber))
                break
            case "QuizButtonRestart":
                newQuestionNumber = 1

                clearQuizAnswers(blockNumber)
                hide(getElement("QuizButtonRestart." + blockNumber))
                break
            default:
        }

        // If there is the next question
        if (newQuestionNumber != 0) {
            newItem = getElement("QuizQuestion." + blockNumber + "." + newQuestionNumber)
        }

        hide(activeItem)
        show(newItem)
        setQuizButtonNext(blockNumber, newQuestionNumber)
        setQuizButtonFinish(blockNumber, newQuestionNumber)
    } catch (error) {
        hide(activeItem)
        hide(getElement("QuizButtonFinish." + blockNumber))
        hide(getElement("QuizButtonRestart." + blockNumber))
        setQuizButtonNext(blockNumber, 0)
        setQuizButtonFinish(blockNumber, 0)

        show(getElement("QuizResult." + blockNumber))
        throw (error)
    }
}

// Returns element with quiz result by checked inputs values sum
function getQuizResultElement(blockNumber) {
    let score = getQuizTotalScore(blockNumber)

    // results.id format = QuizResult.2.0.6
    let results = getElementsByIdStart("QuizResult." + blockNumber)

    for (let i = 0; i < results.length; i++) {
        const ids = results[i].id.split(".")

        if (score >= Number(ids[2]) && score <= Number(ids[3])) {
            return results[i]
        }
    }

    throw ("Error at function getQuizResultElement. Quiz Score (" +score+ ") does not fit in any result range")
}

// Returns sum of checked inputs values
function getQuizTotalScore(blockNumber) {
    let answers = getQuizAnswers(blockNumber)
    let totalScore = 0

    for (let i = 0; i < answers.length; i++) {
        if (parseInt(answers[i].value))
            totalScore += parseInt(answers[i].value)
    }

    return totalScore
}

window.onAnswerChange = (blockNumber, questionNumber) => {
    setQuizButtonNext(blockNumber, questionNumber)
    setQuizButtonFinish(blockNumber, questionNumber)
}

// Hide/show or enable/disable QuizButtonFinish
function setQuizButtonFinish(blockNumber, questionNumber) {
    let answers = getQuizAnswers(blockNumber).length
    let questions = getQuizQuestionsCount(blockNumber)
    let button = getElement("QuizButtonFinish." + blockNumber)

    if (questions == questionNumber) {
        show(button)

        if (answers == questions) {
            enable(button)
        } else {
            disable(button)
        }
    } else {
        hide(button)
    }
}

// Sets inputs checked property to false for current quiz or question
function clearQuizAnswers(blockNumber, questionNumber) {
    let answers = getQuizAnswers(blockNumber, questionNumber)

    for (let i = 0; i < answers.length; i++) {
        answers[i].checked = false
    }
}

// Returns inputs list with checked property for current question or quiz if questionNumber is not specified
function getQuizAnswers(blockNumber, questionNumber) {
    let answers = []
    let selector = "QuizAnswers." + blockNumber

    if (questionNumber != null) {
        selector = selector + "." + questionNumber
    }

    let inputs = document.querySelectorAll("input:checked")
    
    for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].name.startsWith(selector)) {
            answers.push(inputs[i])
        }
    }

    return answers
}

// Returns active question item (excludes questions with "hidden" class)
function getActiveQuizItem(blockNumber) {
    let items = document.getElementsByName("QuizItem." + blockNumber)

    for (let i = 0; i < items.length; i++) {
        if (items[i].classList.length == 0) {
            return items[i]
        }
    }
}

// Hide/show or enable/disable QuizButtonNext
function setQuizButtonNext(blockNumber, questionNumber) {
    let next = getElement("QuizButtonNext." + blockNumber)
    let isAnswered = getQuizAnswers(blockNumber, questionNumber).length > 0

    if (questionNumber == getQuizQuestionsCount(blockNumber) || questionNumber == 0) {
        //QuizButtonFinish pressed
        hide(next)
    } else {
        show(next)
    }

    if (isAnswered) {
        enable(next)
    } else {
        disable(next)
    }
}

// Returns element value by id that starts with "QuizQuestionsCount"
function getQuizQuestionsCount(blockNumber) {
    return getElement("QuizQuestionsCount." + blockNumber).value
}

//Returns element by id
function getElement(id) {
    return document.getElementById(id)
}

// Adds a hidden class to an element
function hide(element) {
    element.classList.add("hidden")
}

// Removes the element hidden class
function show(element) {
    element.classList.remove("hidden")
}

function enable(element) {
    element.disabled = false
}

function disable(element) {
    element.disabled = true
}

// Returns elements whose ids start with the supplied string
function getElementsByIdStart(startString) {
    let ret = []
    let elements = document.getElementsByTagName('*')

    for (let i = 0; i < elements.length; i++) {
        if ((elements[i].id).startsWith(startString)) {
            ret.push(elements[i])
        }
    }

    return ret
}
